/* Erzwingt die kompakte Kopfzeile mit Menue-Button (die Variante,
   die Horizon sonst nur auf dem Handy nutzt) auf allen Bildschirm-
   groessen.

   Horizon setzt data-menu-style per JS auf "menu" oder "drawer".
   Wir setzen es zurueck auf "drawer", sobald es sich aendert.
   Defensiv: schlaegt etwas fehl, bleibt die Standardleiste. */
(function () {
  function force() {
    try {
      var header = document.querySelector('#header-component');
      if (header && header.dataset.menuStyle !== 'drawer') {
        header.dataset.menuStyle = 'drawer';
      }
    } catch (e) {
      /* still */
    }
  }

  function start() {
    force();
    try {
      var header = document.querySelector('#header-component');
      if (!header) return;
      new MutationObserver(force).observe(header, {
        attributes: true,
        attributeFilter: ['data-menu-style']
      });
      window.addEventListener('resize', force);
      window.addEventListener('pageshow', force);
    } catch (e) {
      /* ohne Observer bleibt der Startzustand */
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
